import React from 'react';
import { CSpinner } from '@coreui/react';
import clsx from 'clsx';

const CenterSpinner = ({ classWrapper }) => {
     return (
          <div className={clsx('center-spinner text-center', { [classWrapper]: classWrapper } )}>
               <CSpinner color='primary' />
          </div>
     );
};

export default CenterSpinner;
